import React from 'react';
import { connect } from 'react-redux';
import { FILE_FORMAT_PDF_IMAGE } from '../../utils/constants';
import FileUploadLinksNew from '../file-upload-links/FileUploadLinksNew';
import './file-upload-links.css';
import './common-file-upload.css';
import PropTypes from 'prop-types';
import { change } from 'redux-form';

class CommonFileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageMetaData: {
        actual_file_name: null,
        fileSrc: null,
        isEverificationSuccessful: true,
        fieldscustom: null
      }
    };
  }
  shouldComponentUpdate(nextProps) {
    if (nextProps.resetFile !== this.props.resetFile) {
      this.clearFile();
    }
    return true;
  }
  clearFile = () => {
    const { dispatch, fieldscustom } = this.props;
    let currentFieldState = this.state.imageMetaData;
    if (currentFieldState.fileSrc) {
      currentFieldState.actual_file_name = null;
      currentFieldState.fileSrc = null;
      this.setState({ imageMetaData: currentFieldState });
      dispatch && dispatch(change(this.props.formName, fieldscustom.file_field_name, ''));
    }
  };
  onChangeFile = ({ target, docTypeString, document_code, is_back_file, isInvalid, type }) => {
    let input = target,
      dataURL,
      reader = new FileReader();
    reader.readAsDataURL(input.files[0]);
    reader.onload = () => {
      // to get dataURL
      dataURL = reader.result;
      this.setFile({
        dataURL,
        fileName: input.files[0].name,
        document_code,
        is_back_file,
        docTypeString,
        isInvalid,
        type
      });
      input.value = ''; //to allow re-selecting of the same file
    };
  };
  setFile = async ({ dataURL, fileName, isInvalid }) => {
    let imgDataArray = this.state.imageMetaData;
    imgDataArray.actual_file_name = fileName;
    imgDataArray.fileSrc = isInvalid ? '' : dataURL;
    await this.setState({ imageMetaData: imgDataArray });
  };
  buildImageMetaData = async (fieldscustom = this.props.fieldscustom) => {
    if (fieldscustom) {
      let imgData = this.state.imageMetaData;
      if (fieldscustom.fileSrc) {
        imgData.fileSrc = fieldscustom.fileSrc;
        imgData.actual_file_name = fieldscustom.actual_file_name;
      } else {
        imgData.fileSrc = null;
        imgData.actual_file_name = null;
      }
      await this.setState({ imageMetaData: imgData });
    }
    window.scrollTo(0, 0);
  };

  async UNSAFE_componentWillMount() {
    await this.buildImageMetaData();
  }

  render() {
    const { fileSrc, actual_file_name } = this.state.imageMetaData;
    const {
      fieldscustom,
      toggleFeature,
      disableForm,
      showSampleImageFlag,
      uploadImage,
      docTypeString,
      acceptedFormats
    } = this.props;
    let newObj = {
      disableForm: disableForm || false,
      docTypeString: docTypeString || 'PDF',
      linkEle: { ...fieldscustom, fileSrc, actual_file_name },
      index: 0,
      toggleFeature: toggleFeature || true,
      acceptedFormats
    };
    let new_obj = Object.assign({}, JSON.parse(JSON.stringify({ ...newObj })));
    return (
      <FileUploadLinksNew
        {...new_obj}
        clearFile={this.clearFile}
        onChangeFile={this.onChangeFile}
        formName={this.props.formName}
        country_code={this.props.country_code || ''}
        currentScreen={this.props.currentScreen || ''}
        account_type={this.props.account_type || ''}
        validate={this.props.validate || FILE_FORMAT_PDF_IMAGE}
        isShowSamplePhoto={false}
        device={this.props.device}
        showSampleImageFlag={showSampleImageFlag}
        uploadImage={uploadImage}
        smallPreview={this.props.smallPreview}
      />
    );
  }
}

CommonFileUpload.propTypes = {
  resetFile: PropTypes.bool,
  fieldscustom: PropTypes.any,
  dispatch: PropTypes.any,
  toggleFeature: PropTypes.bool,
  disableForm: PropTypes.any,
  showSampleImageFlag: PropTypes.bool,
  uploadImage: PropTypes.string,
  formName: PropTypes.string,
  country_code: PropTypes.string,
  currentScreen: PropTypes.string,
  account_type: PropTypes.string,
  validate: PropTypes.any,
  device: PropTypes.any,
  smallPreview: PropTypes.bool,
  docTypeString: PropTypes.string,
  acceptedFormats: PropTypes.array
};

export default connect()(CommonFileUpload);
